// extracted by mini-css-extract-plugin
export var actions = "_42-0";
export var actionsContainer = "_42-6";
export var border = "_42-1";
export var childFullHeight = "_42-d";
export var collapse = "_42-2";
export var content = "_42-8";
export var contentChild = "_42-c";
export var fullscreen = "_42-a";
export var headerContainer = "_42-3";
export var headerRow = "_42-5";
export var hidePadding = "_42-9";
export var noScrollX = "_42-e";
export var noScrollY = "_42-f";
export var optOutTopPadding = "_42-b";
export var pagePadding = "_42-7";
export var profile = "_42-g";
export var profileContainer = "_42-h";
export var profileImage = "_42-i";
export var profileMain = "_42-j";
export var profileSubtitle = "_42-l";
export var profileTitle = "_42-k";
export var tabsWrapper = "_42-4";
export var title = "_42-m";